import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class DocumentedInformation extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'documentedInformation'}
            title={ t('support.procedure.P8.title') }
            exportTitle={ t('support.procedure.P8.exportTitle') }
            exportFileName={'documentedInformation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (DocumentedInformation);